export default __webpack_public_path__ + "67fb0d0f464d20c260cde3dd1162872e.png";